import * as z from 'zod/mini';
import { defineFormInput } from './defineFormInput.js';
/**
 * Schema for text input configuration.
 * Use as fallback when structured options (single/multi-select) are not suitable.
 */
export const TextInput = defineFormInput({
    type: 'TEXT',
    input: {
        question: z
            .string()
            .check(z.describe('Question to display. Use only when single/multi-select are inappropriate.')),
    },
    description: 'Free-form text input. Use as fallback when structured options are not suitable.',
    value: {
        value: z.string(),
    },
});
//# sourceMappingURL=TextInput.js.map